import { BackgroundImage, Button, Card, Flex, Image, Text } from "@mantine/core";
import type { JSX } from "react";
import type { ChallengeInfo } from "@/sales-tools/challenges/api/getChallengesForEmployee";
import { ChallengeProgression } from "@/sales-tools/challenges/component/ChallengeProgression";
import purpleBackground from "../../../icons/PurpleBackground.png?url";
import { evaluateSoloChallenge } from "../../../utils/evaluateSoloChallenge";
import { getBadgeIcon } from "../../../utils/getBadgeIcon";
import { getAnnouncementEndConfig } from "../maps";

export function AnnouncementEndSoloContent({
    challenge,
    onDismiss,
}: {
    challenge: ChallengeInfo;
    onDismiss: () => void;
    empId: string;
}): JSX.Element {
    const { details, badgeType } = challenge;
    const { height, width } = getBadgeSize(badgeType);
    const myTeam = details[0];
    const result = evaluateSoloChallenge({ myTeam });
    const { mainText, secondaryText, icon } = getAnnouncementEndConfig({
        challengeType: challenge.challengeType,
        result: result,
    });

    return (
        <Card w="450px" shadow="sm" p={0} radius="md" withBorder>
            <BackgroundImage src={purpleBackground} h={160}>
                <Flex justify="center" align="center" h={160}>
                    <Image data-testid="badge-type" src={getBadgeIcon(badgeType)} h={height} w={width} />
                </Flex>
            </BackgroundImage>
            <Flex direction="column" mt="md" p="lg">
                <Flex direction="column" gap={8}>
                    <Flex gap="xs">
                        <Flex w={24} align="center">
                            {icon}
                        </Flex>
                        <Text fw={"var(--mantine-font-weight-heavy)"} fz="xl">
                            {mainText()}
                        </Text>
                    </Flex>
                    <Text>{secondaryText}</Text>
                </Flex>
                <ChallengeProgression challenge={challenge} displayDirection="horizontal" />
                <Flex justify="flex-end">
                    <Button data-testid="acknowledge-challenge-solo" onClick={onDismiss} mt="xl" maw="78px" size="sm">
                        <Text size="sm">Done</Text>
                    </Button>
                </Flex>
            </Flex>
        </Card>
    );
}

function getBadgeSize(badgeType: string): { height: number; width: number } {
    switch (badgeType) {
        case "SOLO_ANIMATED_BADGE":
        case "TEAM_ANIMATED_BADGE":
            return {
                height: 150,
                width: 150,
            };
        default:
            return {
                height: 80,
                width: 80,
            };
    }
}
